export enum VideoView {
  Split = 'presentationAndVideo',
  Video = 'videoOnly',
  Presentation = 'presentationOnly',
}
